import React from "react";

const LpDocTypesHead = () => {
  return (
    <div className="lpServicesHead-container">
      <div className="lpServicesHead-content">
        <h5>Documents</h5>
      </div>
      <h2>
        <span>Document</span> Types
      </h2>
    </div>
  );
};

export default LpDocTypesHead;
